import styled from 'styled-components'
import { ifProp, prop } from 'styled-tools'
import colorsOptions from '../../components/stories/fundamentals/colors-styles/constants'
import {
  textStyleSizeOptions,
  textStyleWeightOptions,
  textStyleSizeStyleOptions,
  textStyleWeightStyleOptions
} from '../../components/stories/fundamentals/text-styles/constants'

export const InsideFormContainer = styled.div`
  position: relative;
`

export const Logout = styled.a`
  cursor: pointer;
`

export const Description = styled.div`
  text-align: center;
`

export const InsideContainer = styled.div`
  background: ${colorsOptions.greys.white};
  max-width: ${prop('maxWidth')}px;
  padding: 80px 6px 30px 6px;
  display: flex;
  flex-direction: column;
  gap: 3rem;
  min-height: 100vh;
  justify-content: center;
  @media (max-width: 767px) {
    padding: 5rem 0 0;
    ${ifProp('isInPopup', 'min-height: unset; padding: 0 16px;')}
  }
  ${ifProp('isInPopup', 'min-height: unset; padding: unset;')}
`

export const LogoSection = styled.div`
  text-align: center;
  @media (max-width: 767px) {
    ${ifProp('isInPopup', 'margin-bottom: 0;')}
  }
  ${ifProp('isInPopup', 'margin-bottom: 28px;')}
`
export const LogoImage = styled.img`
  max-width: 360px;
  width: 100%;
  height: auto;
`

export const FullContainer = styled.div`
  min-height: ${ifProp('isInPopup', 'auto', '100vh')};
  background: ${colorsOptions.greys.white};
  display: flex;
  align-items: center;
  justify-content: center;
  @media (max-width: 767px) {
    padding: 0 40px;
  }
`

export const LoginFormContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`

export const LoginButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-top: 2rem;
`

// 2fa

export const TwofaContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2rem;
`

export const TwofaButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  width: 100%;
`

export const TwofaTitle = styled.span`
  color: ${colorsOptions.greys['grey-90']};

  /* 700 (bold)/700-XL */
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-700']]}
  ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-XL']]}
`

export const TwoFaSubTitle = styled.span`
  color: ${colorsOptions.greys['grey-90']};

  /* 700 (bold)/700-XL */
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-500']]}
  ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-L']]}
`

export const LoginPopupContainer = styled.div`
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 3rem;
`

export const LoginPopupSubTitle = styled.span`
  color: ${colorsOptions.greys.black};
  text-align: center;

  /* 700 (bold)/700-XL */
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-500']]}
  ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-R']]}
`

// Login Banner

export const LoginBannerContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 56px;
  background: ${colorsOptions.greys['grey-10']};
  z-index: 99;
  display: flex;
  align-items: center;
  padding: 0.25rem 1rem;
  gap: 0.5rem;
`

export const LoginBannerLeftContent = styled.div`
  display: flex;
  flex: 1;
  gap: 1rem;
`

export const LoginBannerTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
`

export const LoginBannerTitle = styled.span`
  color: ${colorsOptions.greys['grey-90']};

  /* 700 (bold)/700-S */
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-700']]}
  ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-s']]}
`

export const LoginBannerSubTitle = styled.span`
  color: ${colorsOptions.greys['grey-70']};

  /* 500 (bold)/500-XS */
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-500']]}
  ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-XS']]}
`

export const LoginBannerIconContainer = styled.div`
  display: flex;
  width: 32px;
  height: 32px;
  justify-content: center;
  align-items: center;
  border-radius: 6.557px;
  box-shadow:
    0px 0.118px 0.471px 0px rgba(0, 0, 0, 0.04),
    0px 0.4px 1.412px 0px rgba(0, 0, 0, 0.19);
`

export const FooterLinksContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`

export const FooterLink = styled.div`
  ${textStyleWeightStyleOptions[textStyleWeightOptions['TEXT-500']]};
  color: ${colorsOptions.greys['grey-50']};
  ${textStyleSizeStyleOptions[textStyleSizeOptions['TEXT-R']]};
  display: flex;
  gap: 0.5rem;
  align-items: center;
  justify-content: center;
`
